import React from "react";
import LowerPicture from "../LowerPicture/LowerPicture";
import { ImmediateUnderDiv } from "./style";

function ImmediateUnder() {
  return (
    <ImmediateUnderDiv>
      <div className="inner-container">
        <div className="row">
          <div className="col-md-8 row p-0">
            <LowerPicture />
            <LowerPicture />
          </div>
        </div>
      </div>
    </ImmediateUnderDiv>
  );
}

export default ImmediateUnder;
